"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSegmentationResultSerializedSchema = void 0;
const zod_1 = require("zod");
const AnalysisType_1 = require("../../AnalysisRequirements/AnalysisType");
const NetworkBuilderMessageResult_1 = require("./NetworkBuilderMessageResult");
const NetworkAnalysisNetwork_1 = require("./NetworkAnalysisNetwork");
exports.NetworkSegmentationResultSerializedSchema = zod_1.default.object({
    type: zod_1.default.literal(AnalysisType_1.AnalysisType.NetworkAnalysisSegmentation),
    result: zod_1.default.object({
        processResult: NetworkBuilderMessageResult_1.NetworkBuilderMessageResultSchema,
        viewNetworks: zod_1.default.record(zod_1.default.string(), NetworkAnalysisNetwork_1.INetworkAnalysisNetworkSerializedSchema),
    }),
});
//# sourceMappingURL=NetworkSegmentationResultSerialized.js.map